import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import SearchSection from "./components/SearchSection";
import ResultsSection from "./components/ResultsSection";
import pageNameDefault from "./NameDefault/pageNameDefault";
import { ProductGroupSetPageName , baseURLGetProductGroupPage } from "../Services/client";

// Main component
export default function GroupPage() {
  const [selectedPageNames, setSelectedPageNames] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [productGroup, setProductGroup] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname.split("").slice(14, 16).join("")
  );
  const [searchFilters, setSearchFilters] = useState({
    productGroupId: "",
    productGroupENName: "",
    selectedGroupId: "",
  });
  const [groupSearchInput, setGroupSearchInput] = useState("");
  const [isGroupDropdownOpen, setIsGroupDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const fetchProductGroups = () => {
    axios.get(baseURLGetProductGroupPage).then((response) => {
      setProductGroup(response.data);
      const initialSelectedNames = {};
      response.data.forEach((group) => {
        if (group.PageName) {
          const selectedItem = pageNameDefault.find((item) => item.name === group.PageName);
          if (selectedItem) {
            initialSelectedNames[group.ProductGroupId] = selectedItem.id.toString();
          }
        }
      });
      setSelectedPageNames(initialSelectedNames);
    });
  };

  const handleUpdate = (group) => {
    const selectedId = selectedPageNames[group.ProductGroupId];
    const selectedItem = pageNameDefault.find((item) => item.id === Number(selectedId));

    if (selectedItem) {
      setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: true }));

      axios
        .get(
          `${ProductGroupSetPageName}?groupId=${group.ProductGroupId}&pageName=${selectedItem.name}`
        )
        .then((response) => {
          console.log("API Response:", response.data);
          setTimeout(() => {
            setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: false }));
            fetchProductGroups();
          }, 3000);
        })
        .catch((error) => {
          console.error("Error updating page:", error);
          setLoadingStates((prev) => ({ ...prev, [group.ProductGroupId]: false }));
        });
    } else {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
    }
  };

  const filteredGroups = productGroup.filter((group) => {
    const matchesId = group.ProductGroupId?.includes(searchFilters.productGroupId);
    const matchesENName = group.ProductGroupENName?.toLowerCase().includes(
      searchFilters.productGroupENName.toLowerCase()
    );
    const matchesSelectedGroup =
      searchFilters.selectedGroupId === "" ||
      searchFilters.selectedGroupId === "all" ||
      group.ProductGroupId === searchFilters.selectedGroupId;
    return (matchesId || matchesENName) && matchesSelectedGroup;
  });

  const filteredGroupOptions = productGroup
    .slice()
    .sort((a, b) => a.ProductGroupENName.localeCompare(b.ProductGroupENName))
    .filter((group) =>
      group.ProductGroupENName.toLowerCase().includes(groupSearchInput.toLowerCase())
    );

  useEffect(() => {
    fetchProductGroups();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsGroupDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    setPageLanguage(location.pathname.split("").slice(14, 16).join(""));
  }, [location.pathname]);

  return (
    <div className="groupPage-container">
      <SearchSection
        showAlert={showAlert}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        isGroupDropdownOpen={isGroupDropdownOpen}
        setIsGroupDropdownOpen={setIsGroupDropdownOpen}
        groupSearchInput={groupSearchInput}
        setGroupSearchInput={setGroupSearchInput}
        productGroup={productGroup}
        filteredGroupOptions={filteredGroupOptions}
        dropdownRef={dropdownRef}
        pageLanguage={pageLanguage}
      />

      <div className="groupPage-grid">
        <ResultsSection
          searchFilters={searchFilters}
          filteredGroups={filteredGroups}
          selectedPageNames={selectedPageNames}
          setSelectedPageNames={setSelectedPageNames}
          pageNameDefault={pageNameDefault}
          handleUpdate={handleUpdate}
          loadingStates={loadingStates}
          pageLanguage={pageLanguage}
        />
      </div>
    </div>
  );
}
